import {Jogging} from "./Jogging";

export class YoutubeJogging extends Jogging {
  constructor(pausePlay, resumePlay) {
    super()
    this.started = false
    this.playing = false
    this.pausePlay = pausePlay
    this.resumePlay = resumePlay
    this.speedThreshold = 2.0
  }

  onStartPlay() {
    this.started = true
    this.playing = true
  }

  pause() {
    this.pausePlay()
    this.playing = false
  }

  resume() {
    this.resumePlay()
    this.playing = true
  }

  mainLoop({ pose, hands }) {
    if (!this.started) return

    super.mainLoop({ pose, hands })
    if (this.playing && this.speed < this.speedThreshold) {
      this.pause()
    } else if (!this.playing && this.speed > this.speedThreshold) {
      this.resume()
    }
  }

  renderCamera(ctx, { pose, hands }) {
    super.renderCamera(ctx, { pose, hands })
  }
}



// WEBPACK FOOTER //
// ./src/components/game/YoutubeJogging.js